if (!window.gsapTimelinesInitialized) {
    window.gsapTimelinesInitialized = true;

    gsap.registerPlugin(ScrollTrigger);

    let sections = document.querySelectorAll(
        ".section-circle-scroll-slider, .dual-sticky-columns"
    );
    sections.forEach((section) => {
        if (section.classList.contains("section-circle-scroll-slider")) {
            initCircleGsapSection(section);
        }

        if (section.classList.contains("dual-sticky-columns")) {
            initGsapDualSticky(section);
        }
    });
}
